import i18next from "i18next"
import stroe from '../store/store.ts'
import { saveUserconfig } from "../apis/Apis.js"
import store from "../store/store.ts"

const rx = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi
const isuuid = (id) => rx.test(id)

const setcookie = (key, value) => { document.cookie = key + "=" + JSON.stringify(value) }

const removecookie = (key) => { document.cookie = key + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;" }

const hascookie = (key) => { return document.cookie.split("; ").map(x => x.split("=")).findIndex(x => x[0] == key) >= 0 }

const getcookie = (key) => {
    const keyvalpairs = document.cookie.split("; ").map(x => x.split("="))
    const key_index = keyvalpairs.findIndex(x => x[0] == key)
    if (key_index == -1) {
        console.error("no cookie found for key", key)
        return undefined
    }
    return JSON.parse(keyvalpairs[key_index][1])
}

const isMobileDevice = () => {
    let hasTouchScreen = false;
    if ("maxTouchPoints" in navigator) {
        if (window.matchMedia("only screen and (max-width: 760px)").matches) {
            hasTouchScreen = navigator.maxTouchPoints > 0;
        }
    } else if ("msMaxTouchPoints" in navigator) {
        if (window.matchMedia("only screen and (max-width: 760px)").matches) {
            hasTouchScreen = navigator.msMaxTouchPoints > 0;
        }
    } else {
        const mQ = matchMedia?.("(pointer:coarse)");
        if (mQ?.media === "(pointer:coarse)") {
            hasTouchScreen = !!mQ.matches;
        } else if ("orientation" in window) {
            hasTouchScreen = true; // deprecated, but good fallback
        } else {
            // Only as a last resort, fall back to user agent sniffing
            const UA = navigator.userAgent;
            hasTouchScreen =
                /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
                /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
        }
    }
    return hasTouchScreen
}

// Date object -> Date string in current language (de: "DD.MM.YYYY")
const date2datestring = (date) => (date instanceof Date) ? date.toLocaleDateString(i18next.language) : undefined

// Number -> Date string in current language (de: "DD.MM.YYYY")
const inttime2datestring = (value) => date2datestring(new Date(value))

// Date object -> Datetime string in current language (de: "DD.MM.YYYY, HH:MM:SS")
const date2string = (date) => (date instanceof Date) ? date.toLocaleString(i18next.language) : undefined

// Number -> Datetime string in current language (de: "DD.MM.YYYY, HH:MM:SS")
const inttime2string = (value) => date2string(new Date(value))

const isurl = (string) => {
    const url_regex = "((?:(http|https|Http|Https|rtsp|Rtsp):\\/\\/(?:(?:[a-zA-Z0-9\\$\\-\\_\\.\\+\\!\\*\\'\\(\\)"
    + "\\,\\;\\?\\&\\=]|(?:\\%[a-fA-F0-9]{2})){1,64}(?:\\:(?:[a-zA-Z0-9\\$\\-\\_"
    + "\\.\\+\\!\\*\\'\\(\\)\\,\\;\\?\\&\\=]|(?:\\%[a-fA-F0-9]{2})){1,25})?\\@)?)?"
    + "((?:(?:[a-zA-Z0-9][a-zA-Z0-9\\-]{0,64}\\.)+"   // named host
    + "(?:"   // plus top level domain
    + "(?:aero|arpa|asia|a[cdefgilmnoqrstuwxz])"
    + "|(?:biz|b[abdefghijmnorstvwyz])"
    + "|(?:cat|com|coop|c[acdfghiklmnoruvxyz])"
    + "|d[ejkmoz]"
    + "|(?:edu|e[cegrstu])"
    + "|f[ijkmor]"
    + "|(?:gov|g[abdefghilmnpqrstuwy])"
    + "|h[kmnrtu]"
    + "|(?:info|int|i[delmnoqrst])"
    + "|(?:jobs|j[emop])"
    + "|k[eghimnrwyz]"
    + "|l[abcikrstuvy]"
    + "|(?:mil|mobi|museum|m[acdghklmnopqrstuvwxyz])"
    + "|(?:name|net|n[acefgilopruz])"
    + "|(?:org|om)"
    + "|(?:pro|p[aefghklmnrstwy])"
    + "|qa"
    + "|r[eouw]"
    + "|s[abcdeghijklmnortuvyz]"
    + "|(?:tel|travel|t[cdfghjklmnoprtvwz])"
    + "|u[agkmsyz]"
    + "|v[aceginu]"
    + "|w[fs]"
    + "|y[etu]"
    + "|z[amw]))"
    + "|(?:(?:25[0-5]|2[0-4]" // or ip address
    + "[0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9])\\.(?:25[0-5]|2[0-4][0-9]"
    + "|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\\.(?:25[0-5]|2[0-4][0-9]|[0-1]"
    + "[0-9]{2}|[1-9][0-9]|[1-9]|0)\\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}"
    + "|[1-9][0-9]|[0-9])))"
    + "(?:\\:\\d{1,5})?)" // plus option port number
    + "(\\/(?:(?:[a-zA-Z0-9\\;\\/\\?\\:\\@\\&\\=\\#\\~"  // plus option query params
    + "\\-\\.\\+\\!\\*\\'\\(\\)\\,\\_])|(?:\\%[a-fA-F0-9]{2}))*)?"
    + "(?:\\b|$)"
    return string.toString().match(url_regex)
}

const mapContainerPosition = container => {
    if (!container) return {}
    const mapElement = document.getElementById(container.id)
    const leftOffset = mapElement.offsetLeft
    const rightOffset = window.innerWidth - mapElement.getBoundingClientRect().right
    const midPosition = (mapElement.offsetWidth / 2) + leftOffset
    return { leftOffset, rightOffset, midPosition };
};


function createProjectOptions(project) {

    project.warnings = []
    project.errors = []
    project.label = project.projectName
    project.key = project.projectId
    const has_sections = project.sections.length > 0;
    const expdate = new Date(project.expirationDateActive)
    var today = new Date();
    var nextDate = new Date(new Date().setDate(today.getDate() + 30));
    const diffTime = Math.abs(nextDate - expdate);

    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));


    if (has_sections) {
        let countArea = 0;
        let project_nodes = [];
        let flights_sum = 0;
        let invaliduploaddate = 0;


        project.sections.forEach(section => {

            var count = 0;
            section.processes.forEach((process) => {
                if (process.processTypeId == 5) {
                    count++;
                }

                if (process.processStartTime) {
                    const startdate = new Date(process.processStartTime)

                    if (startdate > expdate) {
                        invaliduploaddate += 1
                    }
                }
            })
            section.flightsCount = count;
            flights_sum += count;

            var section_node = { text: section.sectionName, data: section, type: 'section' };
            countArea = countArea + section.areaSizeQm;
            project_nodes.push(section_node);
        });

        project.countArea = countArea;
        if (flights_sum > project.numberOfFlights) {
            project.errors.push(`max. Fluganzahl überschritten (${flights_sum}/${project.numberOfFlights})`)
        }

        if (invaliduploaddate) {
            project.errors.push(`${invaliduploaddate} Upload(s) nach Projektende`)
        }

    }
    if (diffDays < 30) {
        project.warnings.push(`Your Project is expiring on ${expdate.toDateString()}`)
    }
    return project
}


const toDictionary = (list, key, value) => {
    var returnable = {};
    list.forEach(function (item) {
        var item_value = item[key];
        returnable[item_value] = item[value];
    })
    return returnable;
}

export const getProcessIcon = (processTypeName) => {

    if (["FLIGHT", "BP40_FLIGHT_ZIP", "FLIGHT_ZIP"].includes(processTypeName)) {
        return "/public/images/svg_icons/drone.svg"
    }
    if (["POINTCLOUD"].includes(processTypeName)) {
        return "/public/images/svg_icons/pointcloud.svg"
    }
    if (["PLAN_TIFF"].includes(processTypeName)) {
        return "/public/images/svg_icons/plan.svg"
    }
    if (["MSP", "LRP"].includes(processTypeName)) {
        return "/public/images/svg_icons/sensor.svg"
    }
    if (["VIDEO"].includes(processTypeName)) {
        return "/public/images/svg_icons/video.svg"
    }
    return "/public/images/svg_icons/drone.svg"

}

export const getProcessStatusColor = (processStatus) => {
    let background_color = 'orange'
    if (processStatus == 'FINISHED') {
        background_color = 'green'
    }
    else if (processStatus == 'FAILED') {
        background_color = 'red'
    }
    else if (processStatus == 'INITIALIZED') {
        background_color = 'white'
    }
    else if (processStatus == 'UPLOADED') {
        background_color = 'yellow'
    }
    else if (processStatus == 'DISABLED') {
        background_color = 'grey'
    }
    return background_color
}

export function getConfig() {

    const user = JSON.parse(sessionStorage.getItem("user"))
    return user ? user.config : null

}

export function deepCopy(obj){
    return JSON.parse(JSON.stringify(obj))
}


export function loadScript(scriptSrc, callback) {

    const script = document.createElement("script");
    script.src = scriptSrc
    script.async = true;
    script.onload = () => callback();
    document.body.appendChild(script);

}

/**
 * Extract an array of row IDs from a DataGrid rowSelectionModel (MUI X v8 format).
 * Handles both 'include' and 'exclude' selection models.
 * @param {{ type?: string, ids?: Set<unknown> } | string[] | null | undefined} selectionModel
 * @param {Array<Record<string, any>>} [rows] needed to resolve an 'exclude' selection
 * @param {string} [idKey]
 * @returns {string[]}
 */
export function getSelectedRowIds(selectionModel, rows, idKey = 'userId') {
    if (!selectionModel) return []
    if (Array.isArray(selectionModel)) return selectionModel

    const { type, ids = new Set() } = selectionModel
    if (type === 'include') return Array.from(ids)

    return (rows || []).filter((r) => !ids.has(r[idKey])).map((r) => r[idKey])
}

export function arrayChunk(rawArray, chunkSize) {

    let [list, size] = [rawArray, chunkSize];
    list = [...Array(Math.ceil(list.length / size))].map(_ => list.splice(0, size))
    return list
}

export function generateUUID() {
    return 'XXXxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0,
            v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}


export const saveStateToDB = (appState) =>{

    const d= debounce(()=>{
        saveUserconfig(appState).then(d=>{}).catch(e=>console.log(e))
    },2000)
    d()
  }


let timer = null;

export function debounce(callback, wait = 250) {
  return (...args) => {
    clearTimeout(timer);
    return new Promise((resolve) => {
      timer = setTimeout(
        () => resolve(callback(...args)),
        wait,
      );
    });
  };
  }

  export function calculateYears(date1, date2) {

    if(!date1 && !date2){
        console.error("issue calculating years")
        return 0 
    }
    let ageDifMs = new Date(date1) - new Date(date2)
    let ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }


  const readFileAsync = (file) => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsText(file);
    })
}


export const getBaseUrl = () =>{
     return window.location.origin.includes("localhost") ? "https://staging.x2bim.com" : window.location.origin
}

export const getBlobBaseUrl = () =>{
    return  window.location.origin.includes("localhost") ? "https://staging.x2bim.com" : window.location.origin
}


export const mockedOrthoSensor = [
    {
        "name": "output/ortho.tif",
        "sensorType": {
            "sensorTypeId": 17,
            "sensorTypeName": "OrthoImage",
            "sensorTypeDesc": "added by Firestarter"
        }
    }
]


const get_future_active = (synccomponents, toggled) => {
    var future_active = []

    if(!toggled.includes("all") && synccomponents.includes("all")){
      // do nothing
    } else if(toggled.includes("all") && !synccomponents.includes("all")){
      future_active = ["all","translation","rotation","zoom"]
    } else if(toggled.includes("rotation") && toggled.includes("translation") && toggled.includes("zoom")){
      future_active = ["rotation","translation","zoom","all"]
    } else {
      future_active = toggled.filter(x => x != "all")
    }

    return future_active
}

export const removeUndefinedFromArray = (inputArray) => {
    return inputArray.filter(row=> row !=null && row !==undefined)
}


export const isLocalHostOrStaging = () =>{
    const isStaing = window.location.origin.includes("staging")
    const isLocalHost = window.location.origin.includes("localhost")
    return (isStaing || isLocalHost)
}
export const getBlobStorage = () => {
    return process.env.BLOB_STORAGE
}

  export const validateKML = async (file) => {
    if(typeof FileReader !== 'undefined') {
        try {
            const filestring = await readFileAsync(file);
            
            var kml_dom = new DOMParser().parseFromString(filestring, 'text/xml');

            const is_kml = kml_dom.children[0].tagName == "kml" ? true : false;
            
            if(!is_kml){
                return false;
            }

            var document_found = false;
            var folder_found = false;

            var document = null;

            const children = kml_dom.children[0].children;

            for (let child of children) {
                if(child.tagName == "Document"){
                    console.log("Document found");
                    document = child;
                    document_found = true;
                }
                if(child.tagName == "Folder"){
                    console.log("Folder found");
                    folder_found = true;
                }
            };

            if(!document_found){
                return false;
            }

            if(folder_found){
                return false;
            }

            const polygon_found = document.getElementsByTagName("Polygon").length ? true : false;

            if(!polygon_found){
                return false;
            }

            return filestring;

        }
        catch(err) {
            console.log(err);
            return false;
        }
    }
    else {
        console.log("No compatible web browser");
        return false;
    }
}

export function getProjectContigentData(contgients, processTypes){
    let projectFligtGigaPixel, projectHelisize, projectPointcloudSize, ProjectMSPSize=0;
    if(contgients && contgients.length){

   
        projectFligtGigaPixel= contgients.find(row=>row.processTypeId===processTypes["FLIGHT"].processTypeId)?.amount
        projectHelisize=contgients.find(row=>row.processTypeId===processTypes["FLIGHT"].processTypeId)?.amount
        projectPointcloudSize=contgients.find(row=>row.processTypeId===processTypes["FLIGHT"].processTypeId)?.amount
        ProjectMSPSize= contgients.find(row=>row.processTypeId===processTypes["FLIGHT"].processTypeId)?.amount
}   


    return {projectFligtGigaPixel, projectHelisize, projectPointcloudSize,ProjectMSPSize }
}

export function calculateProjectContigents(processTypes, FlightGigaPixel, heliSize, pointcloudSize, mobileMappingSize){
    return [
        {
            "processTypeId": processTypes["FLIGHT"].processTypeId,
            "amount": Math.floor(Number(parseInt(FlightGigaPixel)))
        },
        {
            "processTypeId": processTypes["PLAN_TIFF"].processTypeId,
            "amount": Math.floor(Number(FlightGigaPixel) + (mobileMappingSize / 10) + (heliSize / 2))
        },
        {
            "processTypeId": processTypes["DGM_TIFF"].processTypeId,
            "amount": Math.floor(Number(FlightGigaPixel))
        },
        {
            "processTypeId": processTypes["DGM_XYZ"].processTypeId,
            "amount": Math.floor(Number(FlightGigaPixel))
        },
        {
            "processTypeId": processTypes["BIM_IFC"].processTypeId,
            "amount": Math.floor(Number(FlightGigaPixel) + (mobileMappingSize / 10) + (heliSize / 2))
        },
        {
            "processTypeId": processTypes["POINTCLOUD"].processTypeId,
            "amount": Math.floor(Number(pointcloudSize))
        },
        {
            "processTypeId": processTypes["ORTHOBILD_TIFF"].processTypeId,
            "amount": Math.floor(Number(heliSize))
        },
        {
            "processTypeId": processTypes["MSP"].processTypeId,
            "amount": Math.floor(Number(mobileMappingSize))
        },
    ]
}


export function calculateProjectQuots(processTypes, FlightGigaPixel, heliSize, pointcloudSize, mobileMappingSize) {

    return {
        "FLIGHT": { unit: "GP", "amount": Math.floor(Number(parseInt(FlightGigaPixel))) },
        "POINTCLOUD": { unit: "GB", "amount": Math.floor(Number(pointcloudSize)) },
        "DGM_TIFF": { unit: "FILES", "amount": Math.floor(Number(FlightGigaPixel)) },
        "DGM_XYZ": { unit: "FILES", "amount": Math.floor(Number(FlightGigaPixel)) },
        "MSP": { unit: "FILES", "amount": Math.floor(Number(mobileMappingSize)) },
        "PLAN_TIFF": { unit: "FILES", "amount": Math.floor(Number(FlightGigaPixel) + (Number(mobileMappingSize) / 10) + (Number(heliSize) / 2)) },
        "ORTHOBILD_TIFF": { unit: "GB", "amount": Math.floor(Number(heliSize)) },
        "BIM_IFC": { unit: "FILES", "amount": Math.floor(Number(FlightGigaPixel) + (mobileMappingSize / 10) + (heliSize / 2)) }
    }
}

export const  exportToCsv =(filename, rows) => {
    var processRow = function (row) {
        var finalVal = '';
        for (var j = 0; j < row.length; j++) {
            var innerValue = row[j] === null ? '' : row[j].toString();
            if (row[j] instanceof Date) {
                innerValue = row[j].toLocaleString();
            };
            var result = innerValue.replace(/"/g, '""');
            if (result.search(/("|,|\n)/g) >= 0)
                result = '"' + result + '"';
            if (j > 0)
                finalVal += ',';
            finalVal += result;
        }
        return finalVal + '\n';
    };

    var csvFile = '';
    for (var i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
    }

    var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}

export const getSubdomain = () => {
    const hostname = window.location.hostname;
    const domainParts = hostname.replace("www.", "").split('.');

    // Handle cases like 'subdomain.example.com' and 'subdomain1.subdomain2.example.com'
    if (domainParts.length >= 3) {
        return domainParts.slice(0, -2).join('.');
    } else if(hostname.includes('localhost') && domainParts.length > 1) {
        return domainParts[0];
    } else {
        return null; // No subdomain
    }
}

export const getLocalDateTimeString = (date) => {
    return date ? new Date(date).toLocaleString("de-de", { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : "-";
}

export const toTestId = (text) => {
  if (typeof text !== "string") return undefined;
  return text.toLowerCase().replace(/\s+/g, "-").replace(/[()]/g, "");
}

export {
    setcookie, removecookie, isMobileDevice, getcookie, hascookie, date2datestring, inttime2datestring,
    date2string, inttime2string, isurl, isuuid, get_future_active, mapContainerPosition, createProjectOptions, toDictionary
}
